import { AHBMessage, AHBMessageStatus, AHBMessageType } from "core/types";
import { AHB_MESSAGE_STATUS, AHB_MESSAGE_TYPE } from ".";

export function isMessageOfType<T extends AHBMessageType>(
  msg: AHBMessage,
  type: T,
): msg is AHBMessage & { type: T } {
  return msg.type === type;
}

export const isAHBWithdrawalMessage = (
  msg: AHBMessage,
): msg is AHBMessage & { type: typeof AHB_MESSAGE_TYPE.WITHDRAWAL } =>
  isMessageOfType(msg, AHB_MESSAGE_TYPE.WITHDRAWAL);

export function isAHBMessageStatus(value: unknown): value is AHBMessageStatus {
  return (
    typeof value === "string" &&
    Object.values(AHB_MESSAGE_STATUS).includes(value as AHBMessageStatus)
  );
}

export const isAHBStatusDelivered = (
  msg: AHBMessage | undefined,
): msg is AHBMessage & { status: typeof AHB_MESSAGE_STATUS.DELIVERED } =>
  msg?.status === AHB_MESSAGE_STATUS.DELIVERED;

export const isAHBStatusRetrying = (
  msg: AHBMessage | undefined,
): msg is AHBMessage & { status: typeof AHB_MESSAGE_STATUS.RETRYING } =>
  msg?.status === AHB_MESSAGE_STATUS.RETRYING ||
  !!(msg && msg.status === undefined);
